<form class="form-edit custom-form" [formGroup]="enquiryForm" (ngSubmit)="onSubmit()" method="post">
    <fieldset>
        <label><i class="fal fa-user"></i></label>
        <input type="text" placeholder="Your Name *" formControlName="name" value="">
        <div class="clearfix"></div>
        <div *ngIf="name.invalid && (name.dirty || name.touched)" class="form-text text-danger text-start">
            <div *ngIf="name.errors?.['required']">Name is required.</div>
        </div>
        <div class="clearfix mt-2"></div>
        <label><i class="fal fa-envelope"></i>  </label>
        <input type="text" placeholder="Email Address*" formControlName="email" value="">
        <div class="clearfix"></div>
        <div *ngIf="email.invalid && (email.dirty || email.touched)" class="form-text text-danger text-start">
            <div *ngIf="email.errors?.['required']">Email is required.</div>
            <div *ngIf="email.errors?.['email']">Email should be valid</div>
        </div>
        <div class="clearfix mt-2"></div>
        <label><i class="fal fa-phone"></i>  </label>
        <input type="text" placeholder="Phone*" value="" formControlName="phone" >
        <div class="clearfix mt-2"></div>
        <div *ngIf="phone.invalid && (phone.dirty || phone.touched)" class="form-text text-danger text-start">
            <div *ngIf="phone.errors?.['required']">Phone is required.</div>
        </div>
        <div class="clearfix mt-2"></div>
        <textarea cols="40" rows="3" formControlName="message"  placeholder="Requirement*"></textarea>
        <div *ngIf="message.invalid && (message.dirty || message.touched)" class="form-text text-danger text-start">
            <div *ngIf="message.errors?.['required']">Requirements detail is required.</div>
        </div>
    </fieldset>
    <button class="btn btn-primary url_btn float-btn" id='{{businessUser.user_name}}'>Send Now <i class="fal fa-bookmark"></i></button>
</form>